import React,{Component} from 'react';

import {formatDateRange} from '../../../shared/utils';

class DateRange extends Component {
  render(){
    const {launchDate,endDate} = this.props;

    return (
      <span className='DateRange'>{formatDateRange(launchDate,endDate)}</span>
    )
  }
}

export default DateRange;



// WEBPACK FOOTER //
// ./src/shared/components/DateRange/index.js